import { render } from "./InitiativeCategoryForm.vue?vue&type=template&id=4408bc99&scoped=true"
import script from "./InitiativeCategoryForm.vue?vue&type=script&lang=js"
export * from "./InitiativeCategoryForm.vue?vue&type=script&lang=js"

import "./InitiativeCategoryForm.vue?vue&type=style&index=0&id=4408bc99&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4408bc99"]])

export default __exports__